export default "__VITE_ASSET__ByD3KLmn__"